module.exports = __webpack_public_path__ + "static/media/death.a91d3110.png";